import Navbar from "@/components/feature/Navbar";
import HeroSection from "./components/HeroSection";
import FoodTechSection from "./components/FoodTechSection";
import IndustrialBiotechSection from "./components/IndustrialBiotechSection";
import WellnessSection from "./components/WellnessSection";
import ContactSection from "./components/ContactSection";
export default function Home() {
  return (
    <div className="min-h-screen bg-[#07080f]">
      <Navbar />
      <main>
        <HeroSection />
        <FoodTechSection />
        <IndustrialBiotechSection />
        <WellnessSection />
        <ContactSection />
      </main>
    </div>
  );
}
